import styled from '@emotion/styled';

export const HeaderContainer = styled.div`
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing[2]};
    margin-bottom: ${({ theme }) => theme.spacing[3]};
`;

export const NotificationWrapper = styled.div`
    display: flex;
    align-items: flex-start;
    background-color: ${({ theme }) => theme.color.red300};
    color: ${({ theme }) => theme.color.white100};
`;

export const ContentContainer = styled.div`
    flex: 1;
`;

export const Title = styled.span`
    font-weight: 600;
`;
